"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatisticApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var StatisticApi = /** @class */ (function () {
    function StatisticApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 查询时间段内每日付款金额
     * @method GET 查询时间段内每日付款金额
     *
     */
    StatisticApi.prototype.payamount = function () {
        return this.http
            .url("/api/Statistic/payamount")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询时间段内每日待付款金额
     * @method GET 查询时间段内每日待付款金额
     *
     */
    StatisticApi.prototype.unpayamount = function () {
        return this.http
            .url("/api/Statistic/unpayamount")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询时间段内每日订单数
     * @method GET 查询时间段内每日订单数
     *
     */
    StatisticApi.prototype.ordercount = function () {
        return this.http
            .url("/api/Statistic/ordercount")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询时间段内每日注册账号量
     * @method GET 查询时间段内每日注册账号量
     *
     */
    StatisticApi.prototype.accountcountbyday = function () {
        return this.http
            .url("/api/Statistic/accountcountbyday")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询注册账号数量
     * @method GET 查询注册账号数量
     *
     */
    StatisticApi.prototype.accountcount = function () {
        return this.http
            .url("/api/Statistic/accountcount")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询时间段内账号注册数量摘要
     * @method GET 查询时间段内账号注册数量摘要
     *
     */
    StatisticApi.prototype.accountCountSummary = function () {
        return this.http
            .url("/api/Statistic/accountcount/summary")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询各等级账号注册数量摘要
     * @method GET 查询各等级账号注册数量摘要
     *
     */
    StatisticApi.prototype.bylevel = function () {
        return this.http
            .url("/api/Statistic/accountcount/bylevel")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询付款金额
     * @method GET 查询付款金额
     *
     */
    StatisticApi.prototype.totalpayamount = function () {
        return this.http
            .url("/api/Statistic/totalpayamount")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询订单付款摘要
     * @method GET 查询订单付款摘要
     *
     */
    StatisticApi.prototype.totalPayamountSummary = function () {
        return this.http
            .url("/api/Statistic/totalpayamount/summary")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询各状态订单数量摘要
     * @method GET 查询各状态订单数量摘要
     *
     */
    StatisticApi.prototype.orderCountSummary = function () {
        return this.http
            .url("/api/Statistic/ordercount/summary")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询存酒记录数摘要
     * @method GET 查询存酒记录数摘要
     *
     */
    StatisticApi.prototype.storagecount = function () {
        return this.http
            .url("/api/Statistic/storagecount")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 待支付金额
     * @method GET 待支付金额
     *
     */
    StatisticApi.prototype.undefray = function () {
        return this.http
            .url("/api/Statistic/undefray")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询资金摘要
     * @method GET 查询资金摘要
     *
     */
    StatisticApi.prototype.summary = function () {
        return this.http
            .url("/api/Statistic/fund/summary")
            .addSecurityHeaders()
            .support('GET');
    };
    /**
     * 查询用户资金摘要
     * @method GET 查询用户资金摘要
     *
     */
    StatisticApi.prototype.usersummary = function () {
        return this.http
            .url("/api/Statistic/fund/usersummary")
            .addSecurityHeaders()
            .support('GET');
    };
    StatisticApi.diOptions = di_1.default.options({
        name: "StatisticApi",
        scope: "Singleton"
    });
    return StatisticApi;
}());
exports.StatisticApi = StatisticApi;
exports.default = StatisticApi;
